<template>
    <div>
        <div class="data-container row">
            <b-table
                show-empty
                :fields="fields"
                :items="cardNumbers"
                responsive
            >
                <template slot="expiration" slot-scope="data">
                    {{ transformDate(data.item.expired_at) }}
                </template>
                <template slot="status" slot-scope="data">
                    <p class="text-capitalize">{{ data.value }}</p>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Datepicker from "vue-bulma-datepicker";
const fields = [
    { key: "card_no", label: "Card Number", sortable: true },
    { key: "expiration", sortable: true },
    { key: "status", sortable: true }
];
export default {
    name: "CardNumbers",
    props: ["customerUuid", "cardNumbers"],
    computed: {
    },
    data() {
        return {
            fields: fields
        };
    },
    components: {
        Datepicker
    },
    methods: {
        transformDate: function(data) {
            return this.$moment(data).format("D MMMM Y");
        }
    }
}
</script>
